export default __webpack_public_path__ + "5cd40a1e9b326c1d62be5d13aebdbe53.png";